import { useHandlers } from '../../../context/page-context';
import type { AccountApiContract } from '../api';

export function useAccountApi(): { accountApi: AccountApiContract } {
  const { apis } = useHandlers();
  return { accountApi: apis.account };
}
